import React, { FC } from "react"
import { Text, TextProps } from "rebass"

const Paragraph: FC<TextProps> = props => (
  <Text fontSize={[2, 3]} px={2} lineHeight={2} {...props}></Text>
)

export default Paragraph
